export { default as Card } from './card'


// WEBPACK FOOTER //
// ./src/components/card/card/index.js